import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import CoachView from './Components/CoachView';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../redux/reducers/savedVersions';

import {
  toggleSaveEditPopup,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies, logoutUserRequest } from '../redux/reducers/login';
import { getUserProgramsFullRequest, selectUserPrograms, resetUserPrograms } from '../redux/reducers/userProgramsFull';

import { selectedContentItem, getAllThinkTools, getAllThinkToolsAndJournals } from '../redux/selectors';

import {
  getTeamMembersFullRequest,
  getTeamMembersFullSuccess,
  getTeamMembersFullFailure,
  selectTeamMember,
  selectThinkTool,
} from '../redux/reducers/teamMembersFull';

const Coach = ({ view }) => <CoachView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  coachFull: state.teamMembersFullReducer,
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  logoutUserRequest: token => dispatch(logoutUserRequest(token)),
  getTeamMembersFullRequest: token => dispatch(getTeamMembersFullRequest(token)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      
    },
    componentWillReceiveProps(nextProps) {
     
    },
  }),
  branch(props => props.coachFull.projects === null, renderComponent(Spinner)),
)(Coach);

Coach.propTypes = {
  view: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Screens/Coach.jsx